var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarMarketplaceIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 1.45834C16.1783 1.45834 16.4582 1.73817 16.4582 2.08334V12.9167C16.4582 13.2619 16.1783 13.5417 15.8332 13.5417H7.49984C7.15466 13.5417 6.87484 13.2619 6.87484 12.9167C6.87484 12.5715 7.15466 12.2917 7.49984 12.2917H15.2082V2.08334C15.2082 1.73817 15.488 1.45834 15.8332 1.45834Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5415 8.75001C3.5415 8.40483 3.82133 8.12501 4.1665 8.12501H12.4998C12.845 8.12501 13.1248 8.40483 13.1248 8.75001C13.1248 9.09519 12.845 9.37501 12.4998 9.37501H4.7915V17.9167C4.7915 18.2619 4.51168 18.5417 4.1665 18.5417C3.82133 18.5417 3.5415 18.2619 3.5415 17.9167V8.75001Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3912 1.6414C15.6353 1.39732 16.031 1.39732 16.2751 1.6414L18.7751 4.1414C19.0192 4.38548 19.0192 4.78121 18.7751 5.02529C18.531 5.26936 18.1353 5.26936 17.8912 5.02529L15.8332 2.96723L13.7751 5.02529C13.531 5.26936 13.1353 5.26936 12.8912 5.02529C12.6472 4.78121 12.6472 4.38548 12.8912 4.1414L15.3912 1.6414Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22456 14.9747C1.46864 14.7307 1.86437 14.7307 2.10845 14.9747L4.1665 17.0328L6.22456 14.9747C6.46864 14.7307 6.86437 14.7307 7.10845 14.9747C7.35252 15.2188 7.35252 15.6145 7.10845 15.8586L4.60845 18.3586C4.36437 18.6027 3.96864 18.6027 3.72456 18.3586L1.22456 15.8586C0.980484 15.6145 0.980484 15.2188 1.22456 14.9747Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMarketplaceIconHover);
export default __webpack_public_path__ + "static/media/sidebar-marketplace-icon-hover.aee7a46e.svg";
export { ForwardRef as ReactComponent };